module.exports = __webpack_public_path__ + "img/list06.f04e835a.jpg";